/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRecherchePlanLocalisationClasseDto } from './FcbRecherchePlanLocalisationClasseDto';
import {
    FcbRecherchePlanLocalisationClasseDtoFromJSON,
    FcbRecherchePlanLocalisationClasseDtoFromJSONTyped,
    FcbRecherchePlanLocalisationClasseDtoToJSON,
} from './FcbRecherchePlanLocalisationClasseDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRecherchePlanLocalisationClasseDtoPaginatedResults
 */
export interface FcbRecherchePlanLocalisationClasseDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRecherchePlanLocalisationClasseDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRecherchePlanLocalisationClasseDto>}
     * @memberof FcbRecherchePlanLocalisationClasseDtoPaginatedResults
     */
    results?: Array<FcbRecherchePlanLocalisationClasseDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRecherchePlanLocalisationClasseDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRecherchePlanLocalisationClasseDtoPaginatedResults interface.
 */
export function instanceOfFcbRecherchePlanLocalisationClasseDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRecherchePlanLocalisationClasseDtoPaginatedResultsFromJSON(json: any): FcbRecherchePlanLocalisationClasseDtoPaginatedResults {
    return FcbRecherchePlanLocalisationClasseDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRecherchePlanLocalisationClasseDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRecherchePlanLocalisationClasseDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRecherchePlanLocalisationClasseDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRecherchePlanLocalisationClasseDtoPaginatedResultsToJSON(value?: FcbRecherchePlanLocalisationClasseDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRecherchePlanLocalisationClasseDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

